module.exports = __webpack_public_path__ + "static/img/banner.64ba4625.jpg";